import { type AnnouncementAction, type AnnouncementCommand, isAnnouncementCommandAction } from '../constants';

export const filterAnnouncementActionsBySupportedCommands = (
  actions: readonly AnnouncementAction[],
  supportedCommands: readonly AnnouncementCommand[] | undefined,
) => {
  return actions.filter(
    (action) => !isAnnouncementCommandAction(action) || supportedCommands?.includes(action.command),
  );
};
